import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

import { SupportedLanguage } from '../i18n/config'

type LanguageState = {
  language: SupportedLanguage
}

type LanguageAction = {
  setLanguage: (language: SupportedLanguage) => void
}

export const useLanguageStore = create<LanguageState & LanguageAction>()(
  persist(
    set => ({
      language: 'es',
      setLanguage: language => set({ language }),
    }),
    { name: 'language-storage', storage: createJSONStorage(() => localStorage) },
  ),
)
